module.exports = __webpack_public_path__ + "bcc07885677b810ac1147daa21eb02df.png";